import React from 'react'
import './unauthorized.css'

export function Unauthorized({ children }) {
    return(
        <div className='unauthorized__wrapper'>

            <div className='unauthorized__container'>

                <div className='unauthorized__logo'>
            
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 207.75 211.59"><g id="Layer_2" data-name="Layer 2"><g id="Layer_2-2" data-name="Layer 2"><polygon className="cls-1" points="43.58 0 78.94 46.83 125.64 46.83 125.64 108.67 172.47 170.69 172.47 46.83 137.3 0 43.58 0"/><polygon className="cls-1" points="148.21 0 177.77 39.37 178.03 39.37 207.75 0 148.21 0"/><path className="cls-2" d="M63.61,25.71,52.47,11l4.94-3.75L84.14,42.53,79.2,46.27,68.06,31.57,28.9,61.25l-4.45-5.87Z" transform="translate(-24.45)"/><path className="cls-2" d="M86.36,104c-11.18,8.47-21.76,6.57-30.14-4.48-8.62-11.37-8.47-22.08,3.27-31L87.65,47.16,92.1,53,63.93,74.37c-7.84,5.95-8.72,13.52-2.77,21.36,5.66,7.47,12.9,8.31,20.75,2.36l28.16-21.34,4.45,5.86Z" transform="translate(-24.45)"/><path className="cls-2" d="M121.64,92l23.07,30.45-4.94,3.75-18.63-24.59-14,10.63,17.37,22.92-4.94,3.74L102.18,116,86.92,127.55l18.77,24.77-4.94,3.74L77.54,125.42Z" transform="translate(-24.45)"/><path className="cls-2" d="M150.24,129.74,166,150.49c6.32,8.34,5.72,16.78-1.39,22.16-5.37,4.07-11.43,5.06-17,.81l-.13.1c2.9,5.87-.18,9.76-4.07,13.49-4,3.54-9.11,7.1-10.2,11.81l-5-6.54c.53-3,6-5.71,9.65-9.85,3.75-3.91,6.71-7.71,2.4-13.39l-10.86-14.33L110.58,169l-4.44-5.87Zm-6.61,33.5c4.12,5.43,9.15,9.11,15.57,4.25,4.38-3.33,5.76-8.06,1.59-13.56l-11-14.58L134.36,151Z" transform="translate(-24.45)"/><path className="cls-2" d="M182.49,172.3l4.45,5.87-44.1,33.42-4.45-5.87Z" transform="translate(-24.45)"/></g></g></svg> */}
                    Tueri

                </div>

                { children }

            </div>                    
                
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/containers/Unauthorized/index.js